const EARTH_RADIUS_KM = 6371;

function toRad(deg) {
  return (deg * Math.PI) / 180;
}

export function haversineDistanceKm(pointA, pointB) {
  const lat1 = pointA?.lat;
  const lng1 = pointA?.lng;
  const lat2 = pointB?.lat;
  const lng2 = pointB?.lng;

  if (
    !Number.isFinite(lat1) ||
    !Number.isFinite(lng1) ||
    !Number.isFinite(lat2) ||
    !Number.isFinite(lng2)
  ) {
    return null;
  }

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_KM * 2 * Math.asin(Math.sqrt(a));
}

export function isPointInsideRadiusKm(point, center, radiusKm) {
  if (!Number.isFinite(radiusKm) || radiusKm <= 0) return false;
  const dist = haversineDistanceKm(point, center);
  if (dist === null) return false;
  return dist <= radiusKm;
}

// Formule géodésique de point de destination (sphère).
function destinationPoint(lat, lng, bearingDeg, distanceKm) {
  const angDist = distanceKm / EARTH_RADIUS_KM;
  const bear = toRad(bearingDeg);
  const latR = toRad(lat);
  const lngR = toRad(lng);

  const sinLat2 =
    Math.sin(latR) * Math.cos(angDist) +
    Math.cos(latR) * Math.sin(angDist) * Math.cos(bear);
  const lat2 = Math.asin(sinLat2);
  const lng2 =
    lngR +
    Math.atan2(
      Math.sin(bear) * Math.sin(angDist) * Math.cos(latR),
      Math.cos(angDist) - Math.sin(latR) * sinLat2
    );

  return [(lng2 * 180) / Math.PI, (lat2 * 180) / Math.PI];
}

export function buildCirclePolygonFeature({ center, radiusKm, steps = 96 }) {
  if (
    !Number.isFinite(center?.lat) ||
    !Number.isFinite(center?.lng) ||
    !Number.isFinite(radiusKm) ||
    radiusKm <= 0
  ) {
    return null;
  }

  const coords = [];
  for (let i = 0; i <= steps; i++) {
    const bearing = (i * 360) / steps;
    coords.push(destinationPoint(center.lat, center.lng, bearing, radiusKm));
  }
  // Ferme le polygone : dernier point == premier point
  coords[steps] = coords[0];

  return {
    type: "Feature",
    geometry: { type: "Polygon", coordinates: [coords] },
    properties: { radiusKm },
  };
}
